/**
 * @Author: Nenad Brcic
 * @Date: 28.05.16
 * @Email: neno@neno.ch
 */

import Relay from 'react-relay';
import SearchResults from './SearchResults';
import PersonEntry from '../Person/Entry';
import ObjectEntry from '../Object/Entry';
import settings from '../../../config/settings';

const SearchResultsContainer = Relay.createContainer(SearchResults, {
    initialVariables: {
        lang: null,
        limit: settings.defaultLimitNumberOfRecords,
        isNavigationActive: true,
        isSearchResultsActive: true,
        showInformation: false,
        isAdvancedSearch: false,
        searchQuery: null,
        searchTitle: null,
        searchPerson: null,
        searchMaterial: null,
        searchInventoryNr: null,
        searchYearFrom: null,
        searchYearTo: null,
        contentTitle: '',
        lastUpdate: null,
    },
    fragments: {
        store: () => Relay.QL`
            fragment on Store {
                objects(
                    lang: $lang,
                    first: $limit,
                    searchQuery: $searchQuery,
                    searchTitle: $searchTitle,
                    searchPerson: $searchPerson,
                    searchMaterial: $searchMaterial,
                    searchInventoryNr: $searchInventoryNr,
                    searchYearFrom: $searchYearFrom,
                    searchYearTo: $searchYearTo,
                    ) {
                    edges {
                        node {
                            id,
                            ${ObjectEntry.getFragment('object')}
                        }
                    }
                },
                designers(lang: $lang, first: $limit, searchQuery: $searchQuery, searchPerson: $searchPerson) {
                    edges {
                        node {
                            id,
                            ${PersonEntry.getFragment('person')}
                        }
                    }
                },
                producers(lang: $lang, first: $limit, searchQuery: $searchQuery, searchPerson: $searchPerson) {
                    edges {
                        node {
                            id,
                            ${PersonEntry.getFragment('person')}
                        }
                    }
                },
            }
        `,
    }
});

export default SearchResultsContainer;


// WEBPACK FOOTER //
// ./app/components/SearchResults/index.js